import { render } from "./ProviderToMatching.vue?vue&type=template&id=20c2a2f9&scoped=true"
import script from "./ProviderToMatching.vue?vue&type=script&lang=js"
export * from "./ProviderToMatching.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup.css?vue&type=style&index=0&id=20c2a2f9&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c2a2f9"]])

export default __exports__